if(!customElements.get('slide-show')) {
    customElements.define('slide-show', class Slideshow extends HTMLElement {
      constructor() {
        super();
        const slideShow = this.getElementsByClassName('slideshow-container')[0];
        let interval;
        if(slideShow.getAttribute('data-is_autoplay') === "true"){
            interval = slideShow.getAttribute('data-autoplayspeed') * 1;
        }else{
            interval = 3600 * 24;
        }
        this.elements = {
            type: this.getAttribute('data-type'),
            items: [...this.getElementsByClassName('item')],
            prevbtn: this.getElementsByClassName('prev_slide_btn')[0],
            nextbtn: this.getElementsByClassName('next_slide_btn')[0],
            activeDelay: 2,
            current: 0,
            interval,
            intervalF: setInterval(this.nextSlide.bind(this), interval)
        }
        if(this.getAttribute('data-type') === "hero_slide"){
            this.elements = {
                ...this.elements,
                controls: [...this.getElementsByClassName('control')],
                descriptionItems: this.querySelectorAll('.item-description p'),
                headerItems: this.querySelectorAll('.item-header')
            }

          
            for(let i = 0;i < this.elements.headerItems.length;i++){
               this.elements.headerItems[i].style.opacity = 1
               // this.elements.headerItems[i].innerHTML = this.TextIntoPeices(this.elements.headerItems[i].innerHTML.trim(),'text');
            }
            for(let i = 0;i < this.elements.descriptionItems.length;i++){
                this.elements.descriptionItems[i].style.opacity = 1
                //this.elements.descriptionItems[i].innerHTML =this.TextIntoPeices(this.elements.descriptionItems[i].innerHTML.trim(),'text')
            } 

        }
        this.init(); 

       
      }

   TextIntoPeices(text,type) {
        const newArr = [];
        if(type === "text"){
          const textArr =  text.split(' ');
          textArr.map(word=>{
          newArr.push(`<span class="vertical-part overflow-hidden inline-block"><p>${word}</p></span>`);
          })
          return newArr.join(' ');
        }else{
          const words = text.split(' ');
          for(let i=0;i<words.length;i++){
              const wordArr = [];
              const textArr = words[i].split('');
              textArr.map(letter=>{
                  wordArr.push(`<span class="vertical-part overflow-hidden inline-block"><p>${letter}</p></span>`);
              });
              newArr.push(`<div class="mx-1 inline-block header-text">${wordArr.join('')}</div>`)
          }
          return newArr.join(' ');
        }
    }


    init() {
        if(this.elements.type === "hero_slide"){
            this.elements.controls.forEach(control => control.addEventListener('click', (e) => { this.clickedControl(e) }));
            this.elements.controls[this.elements.current].classList.add('active');
        }
        this.elements.items[this.elements.current].classList.add('active');
        this.elements.nextbtn && this.elements.nextbtn.addEventListener('click', () => { this.switchSlide(1) });
        this.elements.prevbtn && this.elements.prevbtn.addEventListener('click', () => { this.switchSlide(-1) });
    };

    nextSlide(){
        this.reset();
        if (this.elements.current === this.elements.items.length - 1) this.elements.current = -1; // Check if current slide is last in array
        this.elements.current++;
        if(this.elements.type === "hero_slide"){
            const buttons = this.elements.items[this.elements.current].querySelectorAll(".slide--btn");
            buttons && buttons.length > 0 && [...buttons].map(button => button.setAttribute('tabindex', '0'))
            this.elements.controls[this.elements.current].classList.add('active');
            this.transitionDelay(this.elements.headerItems);
            this.transitionDelay(this.elements.descriptionItems);
        }
        this.elements.items[this.elements.current].classList.add('active');
  
    };

    switchSlide(next){
        if (this.elements.current === this.elements.items.length - 1 && next > 0) this.elements.current = -1;
        if (this.elements.current === 0 && next < 0) this.elements.current = this.elements.items.length;
        this.elements.current += next;
        this.reset();
        clearInterval(this.elements.intervalF);
        if(this.elements.type === "hero_slide"){
            this.elements.controls[this.elements.current].classList.add('active');
            this.transitionDelay(this.elements.headerItems);
            this.transitionDelay(this.elements.descriptionItems);
        }
        this.elements.items[this.elements.current].classList.add('active');
        this.elements.intervalF = setInterval(this.nextSlide.bind(this), this.elements.interval);
      };

    reset(){ // Remove active classes
        this.elements.items.forEach(item => {
         if(this.elements.type === "hero_slide"){
            const buttons = item.querySelectorAll(".slide--btn");
            buttons && buttons.length > 0 && [...buttons].map(button => button.setAttribute('tabindex', '-1'))
          }
         return item.classList.remove('active')
        });
        if(this.elements.type === "hero_slide"){
            //const buttons = this.elements.items.querySelectorAll(".slide--btn");
            //buttons && buttons.length > 0 && [...buttons].map(button => button.setAttribute('tabindex', '-1'))
            this.elements.controls.forEach(control => control.classList.remove('active'));

        }
    };

    clickedControl(e) { // Add active class to clicked control and corresponding slide
        this.elements.current = 0;
        this.reset();
        clearInterval(this.elements.intervalF);
    
        const control = e.target, dataIndex = Number(control.dataset.index);

        control.classList.add('active');
        this.elements.items.forEach((item, index) => { 
          if (index === dataIndex) { // Add active class to corresponding slide
            item.classList.add('active');
          }
        })
        this.elements.current = dataIndex; // Update current slide
        this.transitionDelay(this.elements.headerItems);
       this.transitionDelay(this.elements.descriptionItems);
       this.elements.intervalF = setInterval(this.nextSlide.bind(this), this.elements.interval); // Fire that bad boi back up
    };


    transitionDelay(items) { // Set incrementing css transition-delay for .item-header & .item-description, .vertical-part, b elements
        let seconds;

        items.forEach(item => {
          const children = item.childNodes;
          let count = 1,
          delay;
          seconds = .03;
          
          children.forEach(child => { // iterate through .vertical-part(s) and style b element
            if (child.classList) {
              item.parentNode.classList.contains('active') ? delay = count * seconds + this.elements.activeDelay : delay = count * seconds;
              child.style.transitionDelay = `${delay}s`; // b element
              count++;
            }
          })
        })
    }

   })
}

  